import React, { FC } from 'react';
import { Skeleton as BaseSkeleton, SkeletonProps } from '@mui/material';


export const Skeleton: FC<SkeletonProps> = ({ sx, ...props }) => (
    <BaseSkeleton
        sx={[{
            display: 'inline-block',
        },
        ...Array.isArray(sx) ? sx : [sx]]}
        {...props}
    />
);
